"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageHero = ImageHero;
exports["default"] = void 0;
var _ChevronRight = _interopRequireDefault(require("@tvg/fuse-icons/lib/ChevronRight"));
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _picture = require("../../fuse-picture/src/picture");
var _styledImageHero = require("./styled-image-hero");
var _excluded = ["image", "text", "href", "dataAnalyticsId", "dataTestId"],
  _excluded2 = ["position", "ratio"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var defaultProps = {
  text: {
    headlineTag: 'h2',
    subheadlineTag: 'h2',
    subheadline: undefined,
    description: undefined,
    terms: undefined
  },
  dataTestId: undefined,
  image: {
    fetchPriority: undefined,
    isLazy: true
  },
  dataAnalyticsId: undefined
};
var propTypes = {
  text: _propTypes["default"].shape({
    headline: _propTypes["default"].string.isRequired,
    headlineTag: _propTypes["default"].string,
    subheadline: _propTypes["default"].string,
    subheadlineTag: _propTypes["default"].string,
    description: _propTypes["default"].string,
    terms: _propTypes["default"].string,
    cta: _propTypes["default"].string.isRequired
  }),
  image: _propTypes["default"].shape({
    alt: _propTypes["default"].string.isRequired,
    fetchPriority: _propTypes["default"].oneOf(['auto', 'high', 'low']),
    isLazy: _propTypes["default"].bool,
    position: _propTypes["default"].oneOf(['Left', 'Right']).isRequired,
    ratio: _propTypes["default"].oneOf(['1:1', '4:3']).isRequired,
    fallbackSource: _propTypes["default"].string.isRequired,
    sources: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      srcSet: _propTypes["default"].string.isRequired,
      type: _propTypes["default"].string.isRequired
    }))
  }),
  href: _propTypes["default"].string.isRequired,
  dataAnalyticsId: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string
};

/**
 * Function returns tabletHeadlineSize and desktopHeadlineSize based on the character count passed
 * @param {number} headlineCharacterCount - Total number of characters of the Image Hero Heading
 * @returns {array} [tabletHeadlineSize, desktopHeadlineSize]
 */
var getHeadlineSize = function getHeadlineSize(headlineCharacterCount) {
  if (headlineCharacterCount < 16) return [6, 11];
  if (headlineCharacterCount > 15 && headlineCharacterCount < 30) return [5, 9];
  if (headlineCharacterCount > 29 && headlineCharacterCount < 45) return [4, 8];
  return [4, 8];
};
function ImageHero(_ref) {
  var image = _ref.image,
    text = _ref.text,
    href = _ref.href,
    dataAnalyticsId = _ref.dataAnalyticsId,
    dataTestId = _ref.dataTestId,
    props = _objectWithoutProperties(_ref, _excluded);
  var headlineCharacterCount = text.headline.length;
  var wrapSymbolHeadline = (0, _fuseUtils.transformer)(text.headline);
  var wrapSymbolSubHeadline = (0, _fuseUtils.transformer)(text.subheadline);
  var wrapSymbolDescription = (0, _fuseUtils.transformer)(text.description);
  var _getHeadlineSize = getHeadlineSize(headlineCharacterCount),
    _getHeadlineSize2 = _slicedToArray(_getHeadlineSize, 2),
    tabletHeadlineSize = _getHeadlineSize2[0],
    desktopHeadlineSize = _getHeadlineSize2[1];
  var position = image.position,
    ratio = image.ratio,
    pictureProps = _objectWithoutProperties(image, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_styledImageHero.StyledImageHeroWrapper, _extends({
    href: href,
    "data-analyticsid": dataAnalyticsId,
    "data-testid": dataTestId || 'fuse-image-hero-test-id'
  }, props), /*#__PURE__*/_react["default"].createElement(_styledImageHero.StyledImageHero, {
    position: position
  }, /*#__PURE__*/_react["default"].createElement(_styledImageHero.StyledImageWrapper, {
    ratio: ratio
  }, /*#__PURE__*/_react["default"].createElement(_picture.Picture, pictureProps)), /*#__PURE__*/_react["default"].createElement(_styledImageHero.StyledCopyWrapper, {
    ratio: ratio,
    position: position
  }, /*#__PURE__*/_react["default"].createElement(_styledImageHero.StyledHeading, {
    size: {
      xxs: "3",
      m: "".concat(tabletHeadlineSize),
      l: "".concat(desktopHeadlineSize)
    },
    tag: text.headlineTag,
    type: "display",
    dangerouslySetInnerHTML: {
      __html: text.headline && wrapSymbolHeadline
    }
  }), text.subheadline && /*#__PURE__*/_react["default"].createElement(_styledImageHero.StyledSubHeading, {
    size: {
      xxs: '2',
      l: '4'
    },
    tag: text.subheadlineTag,
    type: "heading",
    dangerouslySetInnerHTML: {
      __html: text.subheadline && wrapSymbolSubHeadline
    }
  }), text.description && /*#__PURE__*/_react["default"].createElement(_styledImageHero.StyledDescription, {
    size: {
      xxs: '1',
      l: '2'
    },
    tag: "p",
    type: "paragraph",
    dangerouslySetInnerHTML: {
      __html: text.description && wrapSymbolDescription
    }
  }), text.terms && /*#__PURE__*/_react["default"].createElement(_styledImageHero.StyledTerms, {
    size: "m2",
    tag: "p",
    type: "paragraph"
  }, text.terms), /*#__PURE__*/_react["default"].createElement(_styledImageHero.ImageHeroSpanButton, {
    icon: /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null),
    iconRight: true,
    size: {
      xxs: 'small',
      m: 'medium',
      l: 'large'
    },
    variant: "secondary",
    tabIndex: "-1"
  }, text.cta))));
}
ImageHero.propTypes = propTypes;
ImageHero.defaultProps = defaultProps;
var _default = exports["default"] = ImageHero;